var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.formComponent,_vm._g({ref:"form",tag:"component"},_vm.formEvents))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }